export default __webpack_public_path__ + "static/media/Rectangle.41702506.svg";